<template lang="pug">
  //- repsonsive
  //- - two rows
  //- - xl: form inside row
  footer.mt-33vh.pb-24.md-pb-12(v-if="site")
    .px-5.uppercase.text-11.flex.justify-between.items-end.flex-wrap.xl-flex-wrap-none
      nav.w-1x2.md-w-auto
        //- links...
        wp-link.inline-block.px-5.md-px-10(v-for="itm in site.footer_menu_left", :link="itm.link") {{ itm.link.title }}
      //- Footer email input
      .order-first.xl-order-none.w-full.xl-w-auto.mb-24.md-mb-12.xl-mb-0.xl-flex-1.flex.xl-justify-center.px-5.md-px-10
        footer-subscription-form.w-full.xl-w-auto
      nav.w-1x2.md-w-auto
        //- links...
        wp-link.inline-block.px-5.md-px-10(v-for="itm in site.footer_menu_right", :link="itm.link") {{ itm.link.title }}
</template>

<script>
import { mapState } from 'vuex'
import wpLink from '@/components/WPLink'
import FooterSubscriptionForm from '@/components/FooterSubscriptionForm'
export default {
  name: 'AppFooter',
  computed: {
    ...mapState(['site'])
  },
  components: { wpLink, FooterSubscriptionForm }
}
</script>

<style>
</style>
